module.exports = __webpack_public_path__ + "img/shangcai.4f450900.png";